<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IVGutu/tc-custom/9781453231487.jpg?1726519217046" alt="This image is the cover for the book Night Boat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Night Boat
      </h1>
      <p class="bookDescription body article font2">
        <b>A scuba diver unearths a sunken U-boat that holds a terrible secret</b> Robert Moore had a cushy life in Baltimore. The son of a bank president, he could have had the old man’s job if he’d just waited in line. But Moore isn’t the patient type, and rather than spend his life trapped behind a desk, he decamped for the Caribbean, to pass his days diving beneath the perfect blue sea. One day, diving deeper than usual, he spies a sunken ship. His investigations disrupt an unexploded depth charge, which hurls Robert to the surface with the sunken ship not far behind. The U-boat, still seaworthy after all these decades, drifts towards the island and gets caught on the reef. A strange knocking echoes from inside the hull, as though something within is still alive. When Robert opens the long-closed hatch, he’ll learn that some sunken treasure is better left undisturbed.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert McCammon
      </h2>
      
      <p class="authorDescription body article">Robert McCammon (b. 1952) is one of the country&rsquo;s most accomplished authors of modern horror and historical fiction, and a founder of the Horror Writers Association. Raised by his grandparents in Birmingham, Alabama, Bram Stoker and World Fantasy Award&ndash;winning McCammon published his first novel, the Revelations-inspired <I>Baal</I>, when he was only twenty-six. His writings continued in a supernatural vein throughout the 1980s, as he produced such bestselling titles as <I>Swan Song</I>, <I>The Wolf&rsquo;s Hour</I>, and <I>Stinger</I>.<BR /><BR /> In 1991, <I>Boy&rsquo;s Life</I> won the World Fantasy Award for best novel. After his next novel, <I>Gone South</I>, McCammon took a break from writing to spend more time with his family. He did not publish another novel until 2002&rsquo;s <I>Speaks the Nightbird</I>. Since then, he has followed &ldquo;problem-solver&rdquo; Matthew Corbett through seven sequels, in addition to writing several non-series books, including <I>The Border </I>and <I>The Listener</I>. McCammon still lives in Birmingham.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?636774e6